import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    // Initialize any necessary state
  }

  submit(event) {
    event.preventDefault()
    
    // Get the form element
    const form = event.currentTarget
    
    // Submit the form with Turbo
    const formData = new FormData(form)

    fetch(form.action, {
      method: form.method,
      body: formData,
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      credentials: "same-origin"
    }).then(response => {
      if (response.ok) {
        return response.text()
      }
      throw new Error("Network response was not ok")
    }).then(html => {
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, "text/html")
      const streams = doc.querySelectorAll("turbo-stream")
      streams.forEach(stream => {
        Turbo.renderStreamMessage(stream.outerHTML)
      })
    }).catch(error => {
      console.error("Error:", error)
      // Handle the error appropriately
    })
  }
} 